<template>
  <div class="register-container payment">
    <div class="text-center">
      <h1 v-if="type === 'success'">商品数が追加されました。</h1>
      <h1 v-else>決済処理が失敗しました。</h1>
    </div>
    <div class="announce-container">
      <div v-if="type === 'success'">
        <span>お支払いありがとうございます。</span>
        <br>
        <br>
        <span>商品数が追加されました。現在の最大商品登録可能数: {{ maxListingAmount }}商品</span>
        <br>
      </div>
      <div v-else>
        <span>お支払い手続きありがとうございます。</span>
        <br>
        <br>
        <span>大変申し訳ございませんが、<br><h3 class="text-red">お支払いを確認することが出来ませんでした。</h3></span>
        <br>
        <span>ご利用できる支払い方法につきましては、<br><a href="https://support.stripe.com/questions/jp-which-cards-and-payment-types-can-i-accept-with-stripe" target="_blank" class="text--underline">こちら</a>をご参照ください</span>
      </div>
    </div>
  </div>
</template>
<script>
import PlanService from '@/services/planservice'
export default {
  data () {
    return {
      type: null,
      maxListingAmount: 0
    }
  },
  created () {
    this.getMyPlan()
    this.type = this.$route.query.type
    if (!this.type) {
      this.$router.push('/not-found')
    }
  },
  methods: {
    async getMyPlan () {
      const self = this
      await PlanService.getMyPlan()
        .then(data => {
          self.maxListingAmount = data.maxListingAmount
        })
        .catch(err => {
          self.error = err
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/setting/PaymentSuccessOrFail.vue